var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tag",class:{'selected': _vm.isSelected}},[_c('span',{staticClass:"tag-name"},[_vm._v(_vm._s(_vm.name))]),_c('img',{staticClass:"tag-close",attrs:{"src":_vm.icon,"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }